import {
  LOADING_PEOPLE_CONTACTS,
  RECEIVE_PEOPLE_CONTACTS,
  RECEIVE_PEOPLE_CONTACTS_ERROR
} from '../../Constants/action-types';

import { PERSON_SEARCH_URL } from '../../functionality/networking';

function requestPeopleContacts() {
  return {
    type: LOADING_PEOPLE_CONTACTS
  };
}

export function receivePeopleContacts(payload) {
  return {
    type: RECEIVE_PEOPLE_CONTACTS,
    payload
  };
}

function requestPeopleContactsError() {
  return {
    type: RECEIVE_PEOPLE_CONTACTS_ERROR
  };
}

export function fetchPeopleContact(
  payload,
  callback,
  setShowManyResultPopup,
  isGettingHistory = false
) {
  return (dispatch) => {
    dispatch(requestPeopleContacts());
    return fetch(PERSON_SEARCH_URL, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((response) => response.json())
      .then((response) => {
        const parsedResponse = response;
        if (parsedResponse.result[0]?.search_query?.too_many_results) {
          // need to check this
          dispatch(receivePeopleContacts(parsedResponse.result[0]));
          setShowManyResultPopup(true);
        } else {
          dispatch(receivePeopleContacts(parsedResponse.result[0]));
          if (callback) {
            callback();
          }
        }
      })
      .catch((error) => {
        dispatch(requestPeopleContactsError(error));
      });
  };
}
